import {
  AiZendeskBusinessImpact,
  AiZendeskSupportRequestType,
} from 'common/src/modules/zendesk/zendesk.enums';
import {z} from 'zod';

export const launchSupportFormInputSchema = z.object({
  requestType: z
    .nativeEnum(AiZendeskSupportRequestType)
    .describe('Always required. The type of issue.'),
  businessImpact: z
    .nativeEnum(AiZendeskBusinessImpact)
    .describe('Always required. The business impact level.'),
  subject: z
    .string()
    .describe('Always required. Short phrase (5 words or fewer) summarizing the issue.'),
  description: z
    .string()
    .describe('Always required. Detailed description of the issue or request.'),
  campaignId: z
    .string()
    .optional()
    .nullable()
    .describe('Optional. The Flight Control Campaign ID, if relevant.'),
  feedId: z
    .string()
    .optional()
    .nullable()
    .describe('Optional. The Flight Control Feed ID, if relevant.'),
  creativeTemplateId: z
    .string()
    .optional()
    .nullable()
    .describe('Optional. The Flight Control Creative Template ID, if relevant.'),
  creativeId: z
    .string()
    .optional()
    .nullable()
    .describe('Optional. The Flight Control Creative ID, if relevant.'),
});
